module.exports = __webpack_public_path__ + "images/cea33de.png";